var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.success)?_c('img',{attrs:{"retry-img":"","src":_vm.computedSrc},on:{"click":function($event){return _vm.$emit('click')}}}):_c('span',{attrs:{"retry-img":""}},[_vm._t("skeleton")],2)}
var staticRenderFns = []

export { render, staticRenderFns }